import { render, staticRenderFns } from "./NewStay.vue?vue&type=template&id=c823e1fa&scoped=true&"
import script from "./NewStay.vue?vue&type=script&lang=js&"
export * from "./NewStay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c823e1fa",
  null
  
)

export default component.exports